<div class="fondo dialog">
  <ng-container cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <h2 mat-dialog-title class="modal-header" cdkDragHandle style="margin-bottom: 1em">
      {{ title }}
    </h2>
  </ng-container>

  <mat-dialog-content>
    <p>
      {{ message }}
    </p>

    <!-- Single input -->
    <ng-container *ngIf="!inputs.length">
      <mat-form-field class="mt-3">
        <mat-label>{{ inputName }}</mat-label>
        <input matInput [(ngModel)]="input" [type]="tipo" />
      </mat-form-field>
    </ng-container>

    <!-- Multiple inputs -->
    <ng-container *ngIf="inputs.length">
      <div *ngFor="let input of inputs">
        <mat-form-field class="mt-3" *ngIf="input.type !== 'checkbox'">
          <mat-label>{{ input.label }}</mat-label>
          <input matInput [(ngModel)]="input.value" [type]="input.type || 'text'" />
        </mat-form-field>
        <mat-checkbox *ngIf="input.type === 'checkbox'" [(ngModel)]="input.value">
          {{ input.label }}
        </mat-checkbox>
      </div>
    </ng-container>
  </mat-dialog-content>

  <br />

  <mat-dialog-actions fxLayoutAlign="end center" style="margin: 0.5em">
    <button mat-raised-button color="primary" (click)="matDialogRef.close(inputs.length ? inputs : input.trim())">
      {{ btnOkText }}
    </button>
    <button mat-raised-button (click)="matDialogRef.close(false)">
      {{ btnCancelText }}
    </button>
  </mat-dialog-actions>
</div>